// Only actual records route to a record bubble and count toward the "N records in this area"
// totals. The lookup also returns standalone `KnockStatus` rows, and those must keep opening the
// address bubble (that's how knock statuses are managed); PestPac pins are not records either.
export const RECORD_ENTITY_TYPES = ['draftlead', 'lead', 'opportunity'] as const

export type RecordEntityType = (typeof RECORD_ENTITY_TYPES)[number]

export function isRecordEntityType(entityType?: string | null): boolean {
  return RECORD_ENTITY_TYPES.includes(
    (entityType ?? '').toLowerCase() as RecordEntityType,
  )
}
